import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ExcelViewerService } from '../../service/excel-viewer.service';
import { RepoApiService } from '../../service/repo-api.service';

@Component({
  selector: 'app-table-delete-modal',
  templateUrl: './table-delete-modal.component.html',
  styleUrls: ['./table-delete-modal.component.scss']
})
export class TableDeleteModalComponent implements OnInit {
  public tableName:string;
  public table_id:number
  public delete_type:string;
  public group_obj:any = {};

  
  constructor(
    @Inject(MAT_DIALOG_DATA) 
    public data: {tableName: string,table_id:number,delete_type:string,group_obj:any,parent_id:string},
    public dialoge:MatDialog,
    public evService:ExcelViewerService,
    public repoService:RepoApiService,
    ) { }
  ngOnInit(): void {
    this.tableName = this.data.tableName;
    this.table_id = this.data.table_id;
    this.delete_type = this.data.delete_type;
    this.group_obj = this.data.group_obj;
  }

  closePopup(){
    this.dialoge.closeAll();
  }

  deletetable(){
    this.evService.deleteTable({tableName:this.tableName,table_id:this.table_id,group_obj:this.group_obj,"parent_id":this.data.parent_id});
    this.dialoge.closeAll();
  }

  deleteGroup(){
    this.evService.deleteGroup({tableName:this.tableName,table_id:this.table_id,group_obj:this.group_obj,"parent_id":this.data.parent_id});
    // this.repoService.deleteGroupInTopline();
    this.dialoge.closeAll();
  }

}
